/**
 * Refuse une URL d’API en HTTP hors localhost (binaire packagé / production).
 */
export function resolveHttpsApiBase(
  raw: string | undefined,
  fallbackHttps: string,
  allowLocalHttp: boolean,
): string {
  const trimmed = raw?.trim().replace(/\/$/, '') ?? '';
  const candidate = trimmed || fallbackHttps;
  try {
    const url = new URL(candidate);
    if (url.protocol === 'https:') return candidate;
    if (
      allowLocalHttp &&
      url.protocol === 'http:' &&
      (url.hostname === 'localhost' || url.hostname === '127.0.0.1')
    ) {
      return candidate;
    }
  } catch {
    /* ignore */
  }
  return fallbackHttps.replace(/\/$/, '');
}

export function isAllowedFetchUrl(raw: string): boolean {
  try {
    const url = new URL(raw);
    if (url.protocol === 'https:') return true;
    return (
      url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1')
    );
  } catch {
    return false;
  }
}
